<template>
  <FloatingInput
    v-model="valueModel"
    type="password"
    :label="label"
    :show-valid-icon="validate || forceShowValidIcon"
    :error="error"
    :is-dark-floating-label="isDarkFloatingLabel"
    @onFocus="focusHandle"
    @onBlur="blurHandle"
  />
</template>

<script>
import FloatingInput from '@/components/FloatingInput';

export default {
  components: {
    FloatingInput,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Create password',
    },
    forceShowValidIcon: {
      type: Boolean,
      default: false,
    },
    hideValidation: {
      type: Boolean,
      default: false,
    },
    isDarkFloatingLabel: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    focusHandle() {
      this.$emit('onFocus');
    },
    blurHandle() {
      this.$emit('onBlur');
    },
  },
  computed: {
    valueModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    validate() {
      if (!this.value) {
        return false;
      }

      // in case if we need to skip validation, like details page - current password
      if (this.hideValidation) {
        return true;
      }

      // Checks if password fulfils all  following policies.
      // - equal or more than 8 characters
      // - must contain uppercase letter
      // - must contain lowercase letter
      // - must contain number
      if (
        this.value.length < 6
        || this.value.length > 50
      ) {
        return false;
      }

      return true;
    },
  },
};
</script>
